<template>
  <div class="container">
    <div class="banner_1"></div>
    <!-- 文旅融合发展 -->
    <div class="level-1 paddT80">
      <Title activeColor='#293333'
             activeText='文旅融合发展'></Title>
      <div class="banner_3 margT80">
        <div class="banner_3_left ">
          <div class="banner_3_left_text margB10">从产业价值提升的角度看待文旅融合</div>
          <div class="banner_3_left_text margB10">就旅游产业的经济价值而言</div>
          <div class="banner_3_left_text margB10">以挖掘产业新动能为基础</div>
          <div class="banner_3_left_text">可划分为四重价值</div>
          <div class="banner_3_left_li margT80">
            <div class="margB20"><span class="banner_3_left_li_number">1</span> <span class="flex1">文旅融合产生的新业态、新产品、新商业模式、新技术、新IP、新媒体能够拓展延伸文化和旅游产业链，形成政府驱动下的多个产业的互动发展。</span></div>
            <div class="margB20"><span class="banner_3_left_li_number">2</span> <span class="flex1">旅游带动的多产业聚集，能够增加当地就业岗位，为大众创业创新提供良好的平台，带动当地老百姓致富。</span></div>
            <div class="margB20"><span class="banner_3_left_li_number">3</span> <span class="flex1">旅游过程中融入文化元素，能够带来消费与人气的聚集，从而提升企业的盈利能力，推动企业良性发展。</span></div>
            <div><span class="banner_3_left_li_number">4</span> <span class="flex1">文化旅游的发展能够带来区域经济总量的增加，提升整体区域经济发展水平。</span></div>
          </div>
        </div>
        <div class="banner_3_right">
          <div class="banner_3-right-text">
            文化的融入增加了旅游的体验感，提升旅游产品吸引力，推动旅游产品实现优化升级。再者，文化可以带来品牌价值的提升，使得旅游本身具有更加丰富的文化感和特色性。最后，文化是上层建筑的价值再升级，是意识形态的价值弘扬，对旅游活动的整体价值有重要的提升作用。
          </div>
        </div>
      </div>
    </div>

    <div class="banner_2"></div>
    <div class="banner_introduce bg-white">
      <p>打通吃、住、行、游、购、娱、厕、导、智、商、养、学、福、情、奇、文、体、农十八大要素内容
      </p>
      <p> 跨界融合/信息互通，让游客畅游全域示范区。</p>
    </div>

    <!-- 应用建设平台 -->
    <div class="platform bg-white">
      <Title activeColor='#293333'
             activeText='应用平台建设'></Title>
      <div class="platform-img">
        <div class="platform-img-1"></div>
        <div class="platform-img-2"></div>
      </div>
      <div class="platform-img-3"></div>
    </div>
    <!-- 基础设施建设 -->
    <div class="facility margT80">
      <Title activeColor='#293333'
             activeText='基础设施建设'></Title>
      <div class="facility-img"></div>
    </div>
  </div>
</template>
<script>
import Title from '../../components/title';
export default {
  components: {
    Title
  },
  data () {
    return {

    }
  },
  mounted () {


  },
  methods: {

  }
}
</script>
<style  scoped>
.container {
  background: #f5f5f5;
  height: 100%;
}
.banner_1 {
  position: relative;
  background: url("../../assets/images/all-tourism/banner_1.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 7rem;
  width: 19.2rem;
}
.banner_2 {
  position: relative;
  background: url("../../assets/images/all-tourism/banner_2.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 6rem;
  width: 19.2rem;
}
.banner_3 {
  position: relative;
  background: url("../../assets/images/all-tourism/banner_3.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 8rem;
  width: 19.2rem;
  overflow: hidden;
}
.banner_3_left {
  width: 50%;
  float: left;
  /* padding: 0.9rem 1.8rem 1.8rem 0; */
  box-sizing: border-box;
  background: rgba(245, 245, 245, 0.9);
  height: 100%;
  padding: 0.8rem 1.8rem 0;
}
.banner_3_right {
  width: 50%;
  float: right;
}
.banner_3_left_text {
  width: fit-content;
  height: 0.4rem;
  background: rgba(75, 128, 194, 1);
  border-radius: 5px;
  margin: auto;
  line-height: 0.4rem;
  font-size: 0.2rem;
  color: #ffffff;
  padding: 0.05rem 0.2rem;
}
.banner_3_left_li {
  font-size: 0.16rem;
  color: #707070;
  line-height: 0.3rem;
  /* margin: 0 1.6rem; */
}
.banner_3_left_li > div {
  display: flex;
}

.banner_3_left_li_number {
  display: inline-block;
  width: 0.6rem;
  height: 0.6rem;
  text-align: center;
  line-height: 0.6rem;
  font-size: 0.3rem;
  background: rgba(75, 128, 194, 1);
  border-radius: 10px;
  color: #ffffff;
  margin-right: 0.2rem;
}
.banner_3-right-text {
  font-size: 0.16rem;
  line-height: 0.3rem;
  padding: 0.4rem;
  width: 6.4rem;
  color: #ffffff;
  background: rgba(75, 128, 194, 0.5);
  margin-top: 0.8rem;
  margin-left: 0.8rem;
}
.banner_introduce {
  font-size: 0.3rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 0.45rem;
  color: rgba(49, 49, 49, 1);
  text-align: center;
  padding: 0.8rem 0 0.4rem 0;
}
.platform {
  padding: 0.8rem 0 1.2rem 0;
  box-sizing: border-box;
}
.platform-img {
  overflow: hidden;
}
.platform-img-1 {
  position: relative;
  background: url("../../assets/images/all-tourism/platform-img-1.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 9rem;
  width: 16.8rem;
  margin-top: 0.8rem;
  float: left;
}
.platform-img-2 {
  position: relative;
  background: url("../../assets/images/all-tourism/platform-img-2.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 9rem;
  width: 16.8rem;
  margin-top: 1.2rem;
  float: right;
}
.platform-tag {
  display: flex;
  width: 17.8rem;
  margin-left: 0.2rem;
  justify-content: space-between;
}
.platform-tag div {
  width: 2.7rem;
  height: 0.7rem;
  background: rgba(41, 51, 50, 1);
  border-radius: 45px;
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.28rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fff;
  margin-top: 0.8rem;
}
.platform-img-3 {
  position: relative;
  background: url("../../assets/images/all-tourism/platform-img-3.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 9.69rem;
  width: 19.2rem;
}
.facility-img {
  position: relative;
  background: url("../../assets/images/all-tourism/facility-img.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 16.8rem;
  height: 4rem;
  margin: 0.8rem auto 1.2rem;
}
</style>